import { Util } from "@grandvisionhq/forms";
import { createImageUrl } from "../../../../Orders/mappers/view/utils/Orders/mappers/view/utils/create-image-url.js";
const toPersonalDetails = (raw) => {
  return {
    dateOfBirth: raw?.dateOfBirth ?? "",
    firstName: raw?.firstName ?? "",
    lastName: raw?.lastName ?? "",
    middleName: raw?.middleName ?? "",
    phone: raw?.phone ?? "",
    salutation: raw?.salutation ?? "",
    ssn: raw?.ssn ?? "",
    preferredGlobalStoreId: ""
  };
};
const personalDetailsSchemaKeys = {
  firstName: "",
  lastName: "",
  dateOfBirth: "",
  middleName: "",
  salutation: "",
  phone: "",
  ssn: "",
  billingAddress: null,
  shippingAddress: null,
  preferredStore: null,
  preferredGlobalStoreId: null
};
const mapFormStateToPersonalDetailsType = (formState) => {
  const personalData = Object.entries(formState).reduce(
    (result, [fieldName, fieldState]) => {
      if (fieldName === "dateOfBirth" && fieldState?.value) {
        if (/^-?\d+$/.exec(fieldState?.value)) {
          const day = fieldState.value.slice(0, 2);
          const month = fieldState.value.slice(2, 4);
          const year = fieldState.value.slice(4, 8);
          return {
            ...result,
            dateOfBirth: [year, month, day].join("-")
          };
        }
        return {
          ...result,
          dateOfBirth: Util.toStandardDateFormat(fieldState?.value)
        };
      }
      if (fieldName === "customerDateOfBirth" && !!fieldState?.value) {
        return {
          ...result,
          dateOfBirth: Util.toStandardDateFormat(fieldState.value)
        };
      }
      if (!(fieldName in personalDetailsSchemaKeys)) {
        return result;
      }
      return { ...result, [fieldName]: fieldState?.value || null };
    },
    {}
  );
  return personalData;
};
const toBillingAddress = (raw) => {
  return {
    additionalStreetInfo: raw?.additionalStreetInfo ?? "",
    additionalAddressInfo: raw?.additionalAddressInfo ?? "",
    city: raw?.city ?? "",
    company: raw?.company ?? "",
    country: raw?.country ?? "",
    postalCode: raw?.postalCode ?? "",
    prefix: raw?.prefix ?? "",
    region: raw?.region ?? "",
    streetName: raw?.streetName ?? "",
    streetNumber: raw?.streetNumber ?? "",
    firstName: raw?.firstName ?? "",
    lastName: raw?.lastName ?? "",
    middleName: raw?.middleName ?? "",
    salutation: raw?.salutation ?? ""
  };
};
const billingAddressSchemaKeys = {
  additionalStreetInfo: "",
  additionalAddressInfo: "",
  city: "",
  firstName: "",
  lastName: "",
  postalCode: "",
  region: "",
  salutation: "",
  streetName: "",
  streetNumber: "",
  middleName: "",
  country: "",
  company: "",
  prefix: ""
};
const mapFormStateToBillingAddressType = (formState) => {
  const billingAddress = Object.entries(formState).reduce(
    (result, [fieldName, fieldState]) => {
      if (!(fieldName in billingAddressSchemaKeys)) {
        return result;
      }
      return { ...result, [fieldName]: fieldState?.value || null };
    },
    {}
  );
  return billingAddress;
};
const toPreferredStore = (raw) => {
  if (raw?.globalStoreId) {
    return {
      globalStoreId: raw.globalStoreId
    };
  }
  return null;
};
const toRecentOrders = (raw) => {
  return raw?.map(({ lineItems, orderDate, orderNumber, paymentStatus }) => {
    const lineItem = lineItems[0];
    let additionalOrderFields = {
      orderImageAlt: "",
      orderImageUrl: ""
    };
    switch (lineItem?.__typename) {
      case "OrderLineItemBundle":
      case "OrderLineItemContactLens":
      case "OrderLineItemRegular":
      case "OrderLineItemSolution":
        additionalOrderFields = {
          orderImageUrl: createImageUrl(lineItem.product.mainImage),
          orderImageAlt: lineItem.product.name[0]?.value ?? ""
        };
        break;
      case "OrderLineItemPrescriptionGlass":
      case "OrderLineItemNonPrescriptionBundle":
        additionalOrderFields = {
          orderImageUrl: createImageUrl(lineItem.mainLineItem.product.mainImage),
          orderImageAlt: lineItem.mainLineItem.product.name[0]?.value ?? ""
        };
        break;
      case "OrderLineItemSubscription":
        additionalOrderFields = {
          orderImageUrl: createImageUrl(lineItem.subscriptionLineItems?.[0]?.product.mainImage),
          orderImageAlt: lineItem.subscriptionLineItems?.[0]?.product.name?.[0]?.value ?? ""
        };
    }
    const recentOrder = {
      orderDate,
      orderNumber,
      paymentStatus: paymentStatus ?? "",
      ...additionalOrderFields
    };
    return recentOrder;
  });
};
export {
  mapFormStateToBillingAddressType,
  mapFormStateToPersonalDetailsType,
  toBillingAddress,
  toPersonalDetails,
  toPreferredStore,
  toRecentOrders
};
//# sourceMappingURL=profile.js.map
